import { render, staticRenderFns } from "./JeecgOrderCustomerModal.vue?vue&type=template&id=1230c526&scoped=true"
import script from "./JeecgOrderCustomerModal.vue?vue&type=script&lang=js"
export * from "./JeecgOrderCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderCustomerModal.vue?vue&type=style&index=0&id=1230c526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230c526",
  null
  
)

export default component.exports